import { Edit } from "@mui/icons-material";
import { Box } from "@mui/material";
import { ReactNode, useState } from "react";

import { ActBlueWebhookIntegration } from "~frontend/__generated__/graphql";
import { PageHeader } from "~frontend/components/PageHeader";
import Table, { TableBox } from "~frontend/components/Table";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";

import { EditIntegrationDialog } from "../integrationList/EditIntegrationDialog";

export const ActBlueIntegrations = ({
  integrations,
}: {
  integrations: ActBlueWebhookIntegration[];
}): ReactNode => {
  const { subaccount } = useSubaccount()!;
  const [editing, setEditing] = useState<ActBlueWebhookIntegration | null>(
    null
  );
  return (
    <Box>
      <PageHeader>ActBlue Opt Ins</PageHeader>

      <TableBox>
        <Table<ActBlueWebhookIntegration>
          columns={[
            { key: "name", title: "Integration", renderValue: row => row.name },
            {
              key: "settings",
              title: "Message",
              align: "left",
              renderValue: row =>
                row.settings?.sendDonationMessage?.script || "(none)",
            },
            {
              key: "createdAt",
              title: "Created",
              align: "left",
              renderValue: row => new Date(row.createdAt).toLocaleString(),
            },
          ]}
          rows={integrations}
          noFooter
          rowActions={(row: ActBlueWebhookIntegration) => [
            {
              id: "edit",
              type: "button",
              icon: <Edit />,
              tooltipLabel: "Edit Integration",
              onClick: () => setEditing(row),
            },
          ]}
          emptyState="No ActBlue Opt In integrations configured for this short code."
        />
      </TableBox>

      {editing ? (
        <EditIntegrationDialog
          integration={editing}
          onClose={() => setEditing(null)}
          subaccountId={subaccount.id}
        />
      ) : (
        <div />
      )}
    </Box>
  );
};
